export default {
  groups: {
    general: '全般',
    navigation: '移動',
    viewer: '3D ビューア',
    editing: '編集',
  },

  scopes: {
    global: 'どこでも',
    viewer: '3D ビューア内',
    designPoints: '設計点テーブル内',
    reportWriteup: 'レポートエディタ内',
  },

  status: {
    'scope-inactive': 'この画面では使えません',
    shadowed: '別のコマンドがこのキーを使用中です',
    'handler-disabled': '今は使えません',
    'no-handler': 'ここでは使えません',
  },

  shortcut: {
    sequenceConnector: '→',
    unbound: 'ショートカットなし',
  },

  recorder: {
    rebind: '変更',
    cancel: 'キャンセル',
    reset: 'リセット',
    listening: 'キーを押してください…',
    reserved:
      '3D ビューアが既にそのキーを使っています。別のキーを選んでください。',
    unusable:
      'このキーは単独ではショートカットにできません。Shift か Ctrl を組み合わせてください。',
    taken: '{{shortcut}} は既に「{{command}}」に割り当てられています。',
    takeover: 'それでも使う',
  },

  dialog: {
    title: 'キーボードショートカット',
    description:
      'ショートカットの横の「変更」を押し、使いたいキーを押します。記録中は Esc でキャンセル、Backspace で割り当てを解除します。',
    customized: '一部のショートカットが既定と異なります。',
    resetAll: 'すべてリセット',
  },

  conflicts: {
    heading: '2 つのコマンドが同じキーを使っています',
    row: '{{shortcut}} — {{commands}}',
    // Joins the command names in a conflict row.
    separator: '、',
  },

  general: {
    showShortcuts: {
      title: 'キーボードショートカットを表示',
      description: 'この一覧を開きます。',
    },
    toggleAssistant: {
      title: 'アシスタントの表示を切り替え',
      description: '右側のチャットパネルを開きます。',
    },
    closeOverlay: {
      title: '開いているダイアログを閉じる',
      description: '最前面のものを閉じます。',
    },
  },

  navigation: {
    goHome: { title: 'ホームへ移動' },
    goMeshgen: { title: 'MeshGen へ移動' },
    goSimops: { title: 'SimOps へ移動' },
  },

  viewer: {
    resetCamera: {
      title: 'カメラをリセット',
      description: 'モデル全体が収まるように戻します。',
    },
  },

  designPoints: {
    selectNext: { title: '次の設計点を選択' },
    selectPrevious: { title: '前の設計点を選択' },
    closeDetail: { title: '詳細パネルを閉じる' },
  },

  reportWriteup: {
    save: {
      title: 'レポートを保存',
      description: 'エディタで入力中でも使えます。',
    },
  },
};
